<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ ticket ? "Update support ticket" : "Add a support ticket" }}
      </p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body has-text-left">
      <div
        v-if="getProfile.isAdmin"
        class="is-flex is-justify-content-space-between mb-4"
      >
        <b-datetimepicker
          v-model="formData.date"
          placeholder="Select a date"
          icon="calendar"
          disabled
        />

        <b-input
          v-model="formData.reportedBy"
          placeholder="username"
          disabled
        />

        <b-select v-model="status">
          <option value="created" key="created">created</option>
          <option value="pending" key="pending">pending</option>
          <option value="resolved" key="resolved">resolved</option>
          <option value="deleted" key="deleted">deleted</option>
        </b-select>
      </div>

      <div v-if="getProfile.isAdmin" class="mb-4">
        <a :href="formData.url">{{ formData.url }}</a>
        <div v-if="formData.meta">
          <p
            v-if="formData.meta.bindFirestore === false"
            class="has-text-danger"
          >
            Not bind firestore
          </p>
          <p v-if="formData.meta.firestoreTimeOffset">
            time offset:
            {{ formData.meta.firestoreTimeOffset.toFixed(1) }}s
          </p>
          <p v-if="formData.meta.moveTime">
            move time: {{ formData.meta.moveTime.toFixed(1) }}s
          </p>
        </div>
      </div>

      <div class="is-flex is-justify-content-space-between">
        <b-field
          class="mb-0"
          label-position="inside"
          label="Issue"
          :type="type ? '' : 'is-danger'"
          :message="type ? '' : 'Please select an issue'"
        >
          <b-select v-model="type">
            <option value="Wrong game result" key="type1">
              Wrong game result
            </option>
            <option value="Opponent cheated" key="type2">
              Opponent cheated
            </option>
            <option value="Others" key="type3">Others</option>
          </b-select>
        </b-field>

        <b-field label-position="inside" label="Move" class="mb-0">
          <b-input v-model="move" maxlength="15" placeholder="Move number"
        /></b-field>
      </div>

      <b-field label-position="inside" label="Issue description" class="mt-4">
        <b-input
          type="textarea"
          required
          v-model="description"
          minlength="10"
          maxlength="200"
          placeholder="Please be specific. We appreciate the details of the issue."
          validation-message="Please provide a proper description of the issue"
          pattern="^\s*\S{0,19}(\s+\S{1,19})*\s*$"
        />
      </b-field>

      <b-field
        v-if="getProfile.isAdmin || response"
        label-position="inside"
        label="Response"
        class="mt-4"
      >
        <b-input
          type="textarea"
          v-model="response"
          placeholder="Response message"
          :disabled="!getProfile.isAdmin"
        />
      </b-field>
    </section>

    <footer class="modal-card-foot is-justify-content-flex-end">
      <b-button label="Cancel" @click="$emit('close')" />
      <b-button
        type="is-primary"
        label="Submit"
        :disabled="
          !getProfile.isAdmin &&
          (!type || !description || description.length < 10)
        "
        @click="handleSubmit"
      />
    </footer>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

const ticketsRef = firestore.collection("tickets");

export default {
  name: "TicketForm",

  props: ["ticket", "reportedBy", "url", "meta"],

  data() {
    return {
      status: null,
      type: null,
      move: null,
      description: null,
      response: null,
    };
  },

  computed: {
    ...mapGetters(["getProfile"]),

    formData() {
      if (this.ticket) {
        return {
          ...this.ticket,
          date: this.ticket.date.toDate(),
          status: this.status,
          type: this.type,
          move: this.move,
          description: this.description,
          response: this.response,
        };
      }

      return {
        date: new Date(),
        reportedBy: this.reportedBy,
        status: "created",
        url: this.url ? this.url : "/#" + this.$route.path,
        meta: this.meta,
        type: this.type,
        move: this.move,
        description: this.description,
        response: this.response,
      };
    },
  },

  watch: {
    ticket: {
      immediate: true,
      handler() {
        if (!this.ticket) return;
        this.status = this.ticket.status;
        this.type = this.ticket.type;
        this.move = this.ticket.move ? this.ticket.move : null;
        this.description = this.ticket.description;
        this.response = this.ticket.response ? this.ticket.response : null;
      },
    },
  },

  methods: {
    handleSubmit() {
      if (this.ticket) {
        ticketsRef.doc(this.ticket.id).update(this.formData);
      } else {
        ticketsRef.add(this.formData);
      }
      this.$emit("close");
    },

    handleModalKeydown(event) {
      // Allow default behavior for input fields
      // const activeElement = document.activeElement;
      // const isInputFocused =
      //   activeElement &&
      //   (activeElement.tagName === "INPUT" ||
      //     activeElement.tagName === "TEXTAREA" ||
      //     activeElement.isContentEditable);

      // if (isInputFocused) {
      //   return; // Let input fields handle the event normally
      // }

      // Optional: Handle specific modal key actions here if needed
      // if (event.key === "Escape") {
      //   this.$emit("close-modal"); // Close the modal on Escape key
      // }

      // Prevent the event from propagating to the global handler
      event.stopPropagation();
    },
  },

  mounted() {
    this.$el.addEventListener("keydown", this.handleModalKeydown);
  },
  beforeDestroy() {
    this.$el.removeEventListener("keydown", this.handleModalKeydown);
  },
};
</script>

<style></style>
